import "core-js/modules/es.array.push.js";
import isSameWeek from "date-fns/is_same_week";
import { dateToString } from "./dateToString";
export const DAYS_IN_A_WEEK = 7;
export const EMPTY_DAY = 0;
export function generateDaysForMonth(year, month) {
  // in JS Date object: 0 - stands for January, 11 - stands for December
  const dateMonth = month - 1;
  const firstDayOfMonthDate = new Date(Date.UTC(year, dateMonth));
  let day = 1;
  let date = firstDayOfMonthDate;
  const days = [];
  while (date.getUTCMonth() === dateMonth) {
    days.push(date);
    day += 1;
    date = new Date(Date.UTC(year, dateMonth, day));
  }
  return days;
}
export function addPadding(weeks) {
  return weeks.map((week, index) => {
    const zeros = new Array(DAYS_IN_A_WEEK - week.length).fill(EMPTY_DAY);
    if (index === 0) {
      return [...zeros, ...week];
    }
    return [...week, ...zeros];
  });
}
function convertMapToArrays(map) {
  return Array.from(map).map(_ref => {
    let [, array] = _ref;
    return array;
  });
}
export function divideIntoWeeks(days, options) {
  let weekNumber = 0;
  const {
    weeks
  } = days.reduce((result, date) => {
    const {
      weeks: partialWeeks,
      previousDate
    } = result;
    const isSameWeekOptions = {
      weekStartsOn: options.weekStartsOn
    };
    const day = options.showFullDates ? date : date.getUTCDate();
    const dateLeft = dateToString(previousDate);
    const dateRight = dateToString(date);
    if (isSameWeek(dateLeft, dateRight, isSameWeekOptions)) {
      var _partialWeeks$get;
      const oldWeek = (_partialWeeks$get = partialWeeks.get(weekNumber)) !== null && _partialWeeks$get !== void 0 ? _partialWeeks$get : [];
      const newWeek = [...oldWeek, day];
      return {
        weeks: partialWeeks.set(weekNumber, newWeek),
        previousDate: date
      };
    }
    weekNumber += 1;
    return {
      weeks: partialWeeks.set(weekNumber, [day]),
      previousDate: date
    };
  }, {
    weeks: new Map(),
    previousDate: null
  });
  return convertMapToArrays(weeks);
}
//# sourceMappingURL=monthCalendarUtils.js.map